/** @domain scheduling -- Recurrence and scheduling fields: time zone, repeat patterns, start/end times. */
import { z } from 'zod';
import { createDomainField } from './types';

const define = createDomainField('scheduling');

export const timeZone = define({
  label: 'Time Zone',
  schema: z.string(),
  adapterHint: 'select',
  displayFormat: 'text',
});

export const repeatEvery = define({
  label: 'Repeat Every',
  placeholder: 'Enter number',
  schema: z.string().regex(/^[0-9]+$/, 'Must be a whole number'),
  adapterHint: 'number',
  displayFormat: 'number',
});

export const repeatUnit = define({
  label: 'Repeat Unit',
  schema: z.string(),
  adapterHint: 'select',
  displayFormat: 'text',
});

export const repeatOnDays = define({
  label: 'Repeat On Days',
  schema: z.array(z.string()),
  adapterHint: 'multi-select',
  displayFormat: 'text',
});

export const recurrenceType = define({
  label: 'Recurrence Type',
  schema: z.string(),
  adapterHint: 'select',
  displayFormat: 'text',
});

export const recurrenceStartDate = define({
  label: 'Recurrence Start Date',
  schema: z.string(),
  adapterHint: 'date',
  displayFormat: 'date',
});

export const recurrenceStartTime = define({
  label: 'Recurrence Start Time',
  schema: z.string(),
  adapterHint: 'time',
  displayFormat: 'text',
});

export const startTime = define({
  label: 'Start Time',
  schema: z.string(),
  adapterHint: 'time',
  displayFormat: 'text',
});

export const endTime = define({
  label: 'End Time',
  schema: z.string(),
  adapterHint: 'time',
  displayFormat: 'text',
});

export const transactionPeriod = define({
  label: 'Transaction Period',
  placeholder: 'Enter period',
  schema: z.string().regex(/^[0-9]+$/, 'Must be a whole number'),
  adapterHint: 'number',
  displayFormat: 'number',
});
